var randId;
$(document).ready(function() {
	var d = new Date(); var n = d.getTime(); 
	randId = 'kc' + Math.random().toString(36).substring(2) + n;
	var kloegcom_url = 'https://www.ontwerpeencase.nl/kloegcom/' + randId; // url van design-tool, moet nog bepaald worden
	$('#ontwerptool').append('<iframe src="'+kloegcom_url+'" style="width: 100%; height: 800px; border: 0px;"></iframe>');
});
    
if (window.addEventListener) {
	window.addEventListener ("message", receive, false);        
} else 
{
	if (window.attachEvent) {
		window.attachEvent("onmessage",receive, false);
	}
}

function receive(event){
	var data = event.data;
	if(typeof(window[data.func]) == "function"){
		window[data.func].call(null, data.params);
	}
}

function orderSuccess(msg){
	console.log(msg);
	var customcase = new Array();
	customcase.push({name: 'key', value: randId});
	customcase.push({name: 'version', value: msg.version});
	customcase.push({name: 'price', value: msg.price});
	customcase.push({name: 'preview', value: msg.preview});
	
	$.post(window.base_url + 'cart.customcase.php', customcase, function(data) {
		if (data.success)
		{
			window.location.href = base_url + 'bestellen';	
		} else {
			alert('Helaas, er is iets fout gegaan. Probeer opnieuw');	
		}
	}, 'json');
	
	// msg object, 3 properties: geselecteerde versie, prijs en preview van ontworpen case (base64 img)
	// met deze info kan product worden toegevoegd aan winkelwagen
} 